export const CALENDER_URL = "https://calendly.com/admin-learnwithstack/ghl-devs";